import React from 'react';
import {OverlayTrigger} from 'react-bootstrap';
import './LexemeSubentries.css';
import './../../../../_css/lexeme.css';
import {LexemeSenses} from './parts/LexemeSenses';
import {LexemeUtilities, getContextTypes, LexemePageInfos, LexemeEditingLevel} from "../../editor/LexemeHelper";
import './../../editor/LexemeEditor.css';
import {LexemePageContext} from "../../LexemePageContext";

import stylesSubentries from './../../../../_css/dictionary/lexemeParts/lexemeSubentries.module.css';
import BUtils from './../../../../utilities/BaseUtilities';
import {userService} from "../../../../_redux/authentication/services/user.services";
import {AdministrationUtilities} from "../../../../administration/AdministrationHelper";
import stylesLexemeTitle from "../../../../_css/dictionary/lexemeParts/lexemeTitle.module.css";
import stylesLexemeSenses from "../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css";


export class LexemeSubentries extends React.Component {
    constructor(props) {
        super(props);

        this.isGlossary = AdministrationUtilities.isGlossary();
        this.isLoggedGlossary = userService.isLogged() && this.isGlossary;
        this.topics =  this.isGlossary ? AdministrationUtilities.getTopics() : null;

        this.state = {
            name: "SUBENTRY",
            item: {}, /*{showOverlay: true}*/
            useSortable: false
        };

        this.morphoOpen = "";
        this.morphoClose = "";
        this.isPureEncyclopedicDict = false;

        this._isActive = this._isActive.bind(this);
        this._handleClick = this._handleClick.bind(this);
        this._onExit = this._onExit.bind(this);
    }

    componentWillMount() {
        var morphoContainer = LexemePageInfos.getLexemeOptions(this.context, "morpho_container");

        if (typeof morphoContainer !== 'undefined' && morphoContainer.length === 2) {
            this.morphoOpen = morphoContainer[0];
            this.morphoClose = morphoContainer[1];
        }

        this.isPureEncyclopedicDict = LexemePageInfos.isPureEncyclopedicByContext(this.context);
    }

    _isActive(item) {
        return LexemeUtilities.isActive(this, item);
        /*if (item.ids == this.state.item.ids)
         return LexemeUtilities.getLexClass(this) + "Active";
         else
         return "";*/
    }

    _createButtonBarTooltip() {
        return LexemeUtilities.createButtonBarTooltip(this);
    }

    _handleClick(item, isPolyFromLexeme) {
        if (!isPolyFromLexeme)
            this.setState({
                item: LexemeUtilities.handleClick(this, item)
            });
    }

    _onExiting() {
        document.getElementById("lex-subentry-button-bar").style.display = "none";
    }

    _onEntering() {
        document.getElementById("lex-subentry-button-bar").style.display = "block";
    }

    _onExit(item) {
        if (this.state.item === item) {
            this.setState({
                item: ''
            })
        }
    }

    _separatedHasMorpho(item) {
        return item.morphologies.filter(function (itemMorpho) {
            return itemMorpho.morphology.length > 0;
        }).length > 0
    }

    /*shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextContext.pageStatus === 'EDITABLE' || nextContext.pageStatus === 'TRANSLATION_SELECTOR';
    }*/


    render() {
        const morphoSeparated = LexemePageInfos.getLexemeOptions(this.context, 'morphology_separated');
        const isPolyFromLexeme = this.props.isPolyFromLexeme;
        const isPolyEdit = typeof this.props.isPolyEdit !== 'undefined' && this.props.isPolyEdit;
        var lexSubentries = this.props.page.subentries;
        var additionalMainClass = isPolyFromLexeme ? "polySubFromLexeme" : "monoSubentries";
        var additionalClass = isPolyFromLexeme ? "polySubFromLexeme" : "";
        var additionalEncyClass = this.isPureEncyclopedicDict ? "encySubFromLexeme" : "";

        const showCgr = typeof isPolyFromLexeme === "undefined" || !isPolyFromLexeme || LexemePageInfos.isEditPageManagerLexemeOptions(this.context, "SHOW_CGR_POLY_IN_PREVIEW");

        var keyCounter = 1;

        //TODO: da ripensare
        if (this.isLoggedGlossaryWithUserTopics && false) {
            const childrenIncluded = document.getElementById('topicChildrenIncluded').checked;
            lexSubentries.forEach((item) => {
                const searchTopics = userService.getSearchTopics();
                const topicsTree = AdministrationUtilities.getTopics();
                var idsToMap = searchTopics.length > 0 ? searchTopics : topicsTree;

                const topicIds = idsToMap.map((item) => {
                    return item.id + '';
                });
                item.senses = item.senses.filter((item) => {
                    var ancestor_ids = null;
                    if (childrenIncluded && item.topic.ancestor_ids !== 'null') {
                        ancestor_ids = item.topic.ancestor_ids.split('^');
                    }

                    var intersection = ancestor_ids !== null ? topicIds.filter((value) => {
                        return ancestor_ids.includes(value);
                    }).length > 0 : false;

                    return (typeof item.topic !== 'undefined' && topicIds.indexOf(item.topic.id) >= 0) || intersection;
                })
            });


            lexSubentries = lexSubentries.filter((item) => {
                return item.senses.length > 0;
            })
        }

        lexSubentries = AdministrationUtilities.filterValidFrontend(lexSubentries, this.context);


        const showOrder = lexSubentries.length > 1 && LexemePageInfos.isEditPageManagerLexemeOptions(this.context, "SHOW_SUBENTRY_NUMBERING");
        var i = 1;
        var subentryList = lexSubentries.map((item) => {
                var isActive = this._isActive(item);
                var isActiveClass = BUtils.joinClasses(isActive, stylesSubentries[isActive]);

                return <div
                    className={BUtils.joinClasses(stylesSubentries[(isPolyFromLexeme ? "lexemePolySubentry" : "lexemeSubentry")], additionalClass)}
                    key={"subentry-" + item.ids} data-ids={item.ids}>
                    { !this.isPureEncyclopedicDict ? <div id={"div-subentry-" + item.ids}
                                                          className={stylesSubentries['lexemeSubentryEdit']}>
                        <div
                            className={BUtils.joinClasses(stylesSubentries['subentryOrder'], stylesSubentries['subentryOrder__showOrder--' + showOrder])}>{BUtils.stringToRoman(i++)}</div>
                        {this.context.pageStatus === LexemeEditingLevel.EDITABLE && showCgr ?
                            <div
                                className={BUtils.joinClasses(stylesSubentries['lexemeSubentryStatus'], stylesSubentries['lexemeSubentryStatus--' + item.status])}>&nbsp;</div> : ""}
                        {isPolyFromLexeme ? <div
                                className={BUtils.joinClasses('lexHighlightable', stylesSubentries[isPolyFromLexeme ? 'cgrPolyDescr' : 'cgrDescr'], stylesSubentries[additionalClass], (showCgr ? '' : stylesSubentries['hidePolySub']))}>{item.cgr.description}</div>
                            :
                            <>
                                <OverlayTrigger delay={8000} key={"key-lexSubentries" + keyCounter++}
                                                rootClose={false}
                                                trigger={"click"}
                                                onExit={() => isPolyFromLexeme ? "" : this._onExit(item)}
                                                onExiting={() => this._onExiting()} onEntering={() => this._onEntering()}
                                                placement={isPolyEdit ? "top" : (LexemeUtilities.isPageEditable(this) ? "top" : "right")}
                                                container={document.getElementById("modal-poly-edit")}
                                                overlay={this._createButtonBarTooltip()}>
                                    <div
                                        className={BUtils.joinClasses(stylesSubentries['lexemeSubentryEditInlineBlock'], isActiveClass, LexemeUtilities.getLexClass(this))}
                                        onClick={() => {
                                            this._handleClick(item, isPolyFromLexeme)
                                        }}>
                                        <div
                                            className={BUtils.joinClasses('lexHighlightable', stylesSubentries['cgrDescr'], stylesSubentries[additionalClass], (showCgr ? '' : stylesSubentries['hidePolySub']))}>{item.cgr.description}</div>
                                    </div>
                                </OverlayTrigger></>}
                        <div
                            className={BUtils.joinClasses(stylesSubentries['morphologies'], (showCgr ? '' : stylesSubentries['hidePolySub']))}>
                            {(morphoSeparated && this._separatedHasMorpho(item)) || item.morphologies[0].morphology.length > 0 ? this.morphoOpen : ""}
                            {morphoSeparated ? (item.morphologies.map((itemMorpho) => itemMorpho.morphology.length > 0 ?
                                <div key={"key-lexSubentries-morphology" + keyCounter++}
                                     className={BUtils.joinClasses(stylesSubentries['morphology'], additionalClass)}><span
                                    className="morphologyLang">{itemMorpho.language + ":"}</span>{itemMorpho.morphology}
                                </div> : "")) : <div
                                className={BUtils.joinClasses(stylesSubentries['morphology'], stylesSubentries['notSeparated'], stylesSubentries[additionalClass])}>{item.morphologies[0].morphology}</div>}
                            {(morphoSeparated && this._separatedHasMorpho(item)) || item.morphologies[0].morphology.length > 0 ? this.morphoClose : ""}
                        </div>
                        {item.subentry_form.length > 0 ?
                            <div
                                className={BUtils.joinClasses(stylesSubentries['subentryForm'], stylesSubentries[additionalClass])}>{item.subentry_form}</div> : ""}
                    </div> : '' }
                    {item.inherited_senses.length > 0 ?
                        <LexemeSenses isInherited={true} isPolyFromLexeme={this.props.isPolyFromLexeme} {...item} /> : ""}
                    <LexemeSenses key={'key-senses-' + item.ids} isInherited={false} isPolyEdit={isPolyEdit}
                                  isPolyFromLexeme={this.props.isPolyFromLexeme} {...item}
                                  polyItem={this.props.isPolyFromLexeme ? this.props.page : undefined}
                                  callbackParent={(newState) => this.setState(this.state)}/>
                </div>
            }
        );


        return <div
            className={BUtils.joinClasses(stylesSubentries['lexemeSubentries'], stylesSubentries[additionalEncyClass], stylesSubentries[additionalMainClass], stylesSubentries[additionalClass], stylesSubentries[(isPolyEdit ? " poly-subs-edit " : "")])}>
            {subentryList}
        </div>;

    }
}

LexemeSubentries.contextType = LexemePageContext;